// -*- Mode: rjsx -*-
import React, { useState } from 'react';

import Skeleton from 'react-loading-skeleton';
import SanitizedHTML from 'react-sanitized-html';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import FancyDate from '../../../ui/FancyDate';

import Header, { CustomHeader } from './Header.jsx';

const style_from_client = {
    backgroundColor: "white",
};
const style_from_helper = {
    backgroundColor: "#ffffee",
};
const style_from_system = {
    backgroundColor: "#DCE1EB",
};

const style_from_mentor = {
    backgroundColor: "pink",
};


const style_for_loading = {
    backgroundColor: "lightgrey",
};

const CONDENSED_TYPES = ['message-from-system'];

const TYPE_STYLES = {
    // from client
    'request': style_from_client,
    
    'message-from-client': style_from_client,
    'request-helper-note': style_from_helper,
    
    'message-from-system': style_from_system,
    'message-from-mentor': style_from_mentor,        

    'fake': style_for_loading,    
};


function getStyleForType(type) {
    return TYPE_STYLES[type] || {};
}
function isCondensed(type) {
    return CONDENSED_TYPES.indexOf(type) !== -1;
}

function NoteContentHTML(props) {
    return <SanitizedHTML html={ props.content } />;    
}

function NoteContentSkeleton() {
    let max = 500;
    let me = 450;
    let [line1] = useState(Math.floor((Math.random() * me)));
    let [line2] = useState(Math.floor((Math.random() * me)));
    let [line3] = useState(Math.floor((Math.random() * me)));    
    return (
        <>
          <Skeleton width={max - line1} /> <Skeleton width={line1} />  <br />
          <Skeleton width={max - line2} /> <Skeleton width={line2} />  <br />
          <Skeleton width={max - line3} /> <Skeleton width={line3} />  <br />
        </>
    );
}

function NoteContent(props) {
    const note = props.note;

    let content = <NoteContentSkeleton />;
    
    if(note.key) {
        if(note.content_type == 'text/html')
            content = <NoteContentHTML content={note.content} />;
        else {
//            console.log("plain text note: %o", note);
            content = note.content; //  + "  " + note.type +  " (plain text)";
        }
    }
    
    return <CardContent> { content } </CardContent>;
}


function HistoryItemFull(props) {

    return (
        <Card variant="outlined" style={{marginBottom: 16, ...props.style }}>
          <Header note={props.note} />
          <NoteContent note={props.note} />
        </Card>
    );
}

// function HistoryItemCondensed(props) {

//     return (
//         <Card variant="outlined" style={{marginBottom: 16, ...props.style }}>
//           <CustomHeader title={props.note.subject} />          
//           <NoteContent note={props.note} />          
//         </Card>
//     );
// }

function HistoryItemSystemWithSubject(props) {
    return (
        <Card variant="outlined" style={{marginBottom: 16, ...props.style }}>
          <CustomHeader
            title={props.note.subject}
          />
          {/* <NoteContent note={props.note} />           */}
        </Card>
    );
}

function HistoryItemSystemWithoutSubject(props) {
    return (
        <Card variant="outlined" style={{marginBottom: 16, ...props.style }}>
          <NoteContent note={props.note} />          
        </Card>
    );
}

function HistoryItemSystem(props) {
    if(props.note.subject)
        return <HistoryItemSystemWithSubject {...props} />;
    else
        return <HistoryItemSystemWithoutSubject {...props} />;    
}

function Item(props) {
    const note = props.note;
    let style = getStyleForType(props.note.type);
    
    if(props.opacity) style = { ...style, 'opacity': props.opacity };
    
    let params = { note: note, style: style };

    switch(props.note.type) {
    case 'message-from-system':
        return <HistoryItemSystem {...params} />;
    default:
        return <HistoryItemFull {...params} />;        
    }
    
    // console.log("type: %o", props.note.type);    
    // if(isCondensed(note.type))
    //     return <HistoryItemCondensed {...params} />;
    // else

}



export default Item;
